import React, { useState, useEffect } from "react";
import { auth, db } from "./firebase";
import {
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  signOut,
  onAuthStateChanged,
} from "firebase/auth";
import { clearIndexedDbPersistence } from "firebase/firestore";
import { sendEmailVerification } from "firebase/auth";


export default function Auth() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [user, setUser] = useState(null);

  // ✅ Keep user in sync with Firebase
  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      setUser(currentUser);
    });
    return () => unsubscribe();
  }, []);

  // Register new user
const register = async () => {
  try {
    const userCredential = await createUserWithEmailAndPassword(auth, email, password);
    const user = userCredential.user;

    // ✅ Send email verification
    await sendEmailVerification(user);

    alert("✅ Registered successfully! Please verify your email before logging in.");
  } catch (error) {
    alert(error.message);
  }
};

  // Login existing user
const login = async () => {
  try {
    const userCredential = await signInWithEmailAndPassword(auth, email, password);
    const user = userCredential.user;

    if (!user.emailVerified) {
      await signOut(auth); // 👈 log them out again
      alert("❌ Please verify your email before logging in.");
      return;
    }

    alert("✅ Logged in successfully!");
  } catch (error) {
    alert(error.message);
  }
};


  // Logout
const logout = async () => {
  try {
    await signOut(auth);  // ✅ logs out user, clears auth tokens
    setUser(null);        // ✅ clears local state immediately
    alert("Logged out!");
  } catch (error) {
    console.error("Error during logout:", error);
    alert("Logout failed: " + error.message);
  }
};

  return (
    <div style={{ maxWidth: "300px", margin: "20px auto", textAlign: "center" }}>
      {!user ? (
        <>
          <h2>Register / Login</h2>
          <input
            type="email"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          /><br />
          <input
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          /><br />
          <button onClick={register}>Register</button>
          <button onClick={login}>Login</button>
        </>
      ) : (
        <>
          <h3>Welcome, {user.email}</h3>
          <button onClick={logout}>Logout</button>
        </>
      )}
    </div>
  );
}
